import { combineReducers } from "@reduxjs/toolkit";
import { apiSlice } from "../services/api/apiSlice";
import { authApi } from "../services/auth/authApi";
import authSlice from "../services/auth/authSlice";

const rootReducer = combineReducers({
  auth: authSlice,
  [authApi.reducerPath]: authApi.reducer,
  [apiSlice.reducerPath]: apiSlice.reducer,
});

export default rootReducer;
